import { render } from "./pollutionPrediction.vue?vue&type=template&id=647e81e0&scoped=true"
import script from "./pollutionPrediction.vue?vue&type=script&lang=js"
export * from "./pollutionPrediction.vue?vue&type=script&lang=js"

import "./pollutionPrediction.vue?vue&type=style&index=0&id=647e81e0&lang=scss"
import "./pollutionPrediction.vue?vue&type=style&index=1&id=647e81e0&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647e81e0"]])

export default __exports__